import { GridContainer, NoData, Span } from "@common";
import { Loader, SearchContent, TablePagination } from "@components";
import { FaPlus } from "@icons";
import { useEffect, useMemo, useState } from "react";
import { COLUMNS } from "./Table/columns";
import { BusinessUnitAdd } from "./Add/BusinessUnitAdd";
import { Button } from "antd";

import { useDispatch, useSelector } from "react-redux";
import { Dispatch, RootState } from "@store";
import { BusinessUnitEdit } from "./Edit/BusinessUnitEdit";

export const BusinessPage = () => {
  const column = useMemo(() => COLUMNS, []);
  const dispatch = useDispatch<Dispatch>();
  const tableName = "business";

  const [openModal, setOpenModal] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState(false);

  const [searchData, setSearchData] = useState({
    filter: "keyword",
    value: "",
  });

  const id: any = useSelector(
    (state: RootState) => state.UI.forms.editBusinessUnit?.id
  );

  const businessData: any[] = useSelector(
    (state: RootState) => state.Table.tables.business.data
  );

  const userAccess = useSelector(
    (state: RootState) => state.User.userInfo?.role_name?.access_group_id
  ); 

  const showDrawer = () => {
    setOpenModal(true);
  };

  const getBusinessData = async () => {
    try {
      setIsLoading(true);
      dispatch.Table.getBusinessCompanies({
        table: tableName,
      });
    } catch (error) {
      throw error;
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    dispatch.UI.updateFormId({
      target: "editBusinessUnit",
      value: null,
    });
    dispatch.Table.updateKeyword({ table: tableName, value: "" });
    getBusinessData();
  }, []);

  const setFilters = () => {
    setIsLoading(true);
    const keyvalue =
      searchData?.value === ""
        ? ""
        : `&${searchData?.filter}=${searchData?.value}`;
    dispatch.Table.updateKeyword({ table: tableName, value: keyvalue });
    dispatch.Table.updatePageIndex({
      table: tableName,
      value: 1,
    });
    setIsLoading(false);
    getBusinessData();
  };

  useEffect(() => {
    dispatch.Table.updatePageIndex({
      table: tableName,
      value: 1,
    });
    setSearchData({ filter: "keyword", value: "" });
  }, []);

  const searchOptions = [
    {
      value: "keyword",
      label: "Keyword",
    },
    {
      value: "company_code",
      label: "Company Code",
    },
    {
      value: "company_name",
      label: "Company Name",
    },
    {
      value: "company_address",
      label: "Address",
    },
    {
      value: "is_active",
      label: "Status",
    },
  ];

  return (
    <>
      <Loader isLoading={isLoading} />
      <div className="main">
        <GridContainer grid="two">
          <Span weight="bold" size="2xl">
            Business Unit
          </Span>
          <div className="search-bar">
            <SearchContent
              searchOptions={searchOptions}
              setFilters={setFilters}
              setSearchData={setSearchData}
              searchData={searchData}
            />

            {userAccess?.business_unit_add && (
              <Button onClick={showDrawer} type="primary" size="large">
                <div className="flex pr-2 items-center">
                  <FaPlus className="my-auto mx-2 text-md items-center inline-flex" />
                  Add
                </div>
              </Button>
            )}
          </div>
        </GridContainer>

        {businessData?.length > 0 ? (
          <TablePagination
            columns={column}
            data={businessData}
            dataType="business-unit"
          />
        ) : (
          <NoData />
        )}

        {/* Add */}
        <BusinessUnitAdd
          openModal={openModal}
          setOpenModal={setOpenModal}
          getData={getBusinessData}
        />

        {/* Edit */}
        {id && <BusinessUnitEdit getData={getBusinessData} company_code={id} />}
      </div>
    </>
  );
};
